import React, { useState } from 'react';
import { Alert, ScrollView, View } from "react-native";
import Text from "../../../../../components/Text";
import Header from "../../../../../navigation/Header";
import tw from "../../../../../styles/tailwind";
import { FeeInfoBlock } from "../../../Resident/Fees/PaymentCheckout/BankTransferPaymentScreen";
import { Image } from "expo-image";
import api from "../../../../../utils/api";
import { useQuery } from "@tanstack/react-query";
import useFormSubmit from "../../../../../hooks/useFormSubmit";
import { TouchableOpacity } from "react-native-gesture-handler";
import dayjs from 'dayjs'
import PaymentDetailModal from './Payments/PaymentDetailModal';
import ChevronChico from '../../../../../components/ChevronChico';


export default function FeeUnitScreen({navigation, route}){
  const { communityId, unit_fee_id, onFeeEdited } = route.params
  const [shownPaymentId, setShownPaymentId] = useState();


  const { isLoading, error, data: feeUnit, refetch } = useQuery({
    queryKey: ['unit-fee.detail', communityId, unit_fee_id],
    queryFn: () => api.get(`/communities/${communityId}/unit-fees/${unit_fee_id}`).then(response => response.data),
  })


  const { submitForm: submitDeletion, isSubmitting: isDeleting } = useFormSubmit({
    onSuccess: () => {
      onFeeEdited?.()
      navigation.goBack()
    },
    onError: (error) => { },
    successToastMessage: "Adeudo eliminado",
    method: "delete",
    endpoint: `/communities/${communityId}/unit-fees/${unit_fee_id}`,
  })



  function confirFeeUnitDeletion() {
    Alert.alert('¿Eliminar este adeudo?', '', [
      {
        text: 'Cancelar',
        onPress: () => { },
        style: 'cancel',
      },
      { text: 'OK', onPress: () => submitDeletion({}) },
    ]);
  }

  const hasEvidences = (feeUnit?.evidences?.length > 0)
  const hasPayments = (feeUnit?.payments?.length > 0)


  return (
    <>
      <Header showBackButton style={tw`bg-transparent`}>
        {
          isLoading &&
          <Text style={tw`text-secondary`}>Cargando...</Text>
        }
        {
          feeUnit &&
          <Text style={tw`text-lg text-secondary`}>{feeUnit.fee.name}</Text>
        }
      </Header>

      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`py-2 px-6`}>
        {
          feeUnit &&
          <View style={tw``}>
            <FeeInfoBlock feeUnit={feeUnit} showUnitDetails />

            <View style={tw`row`}>
              <Text style={tw`mr-5`}>Estado:</Text>

              {
                feeUnit.paid > 0 &&
                  <Text style={tw`font-500`}>Pagado</Text>
              }
              {
                feeUnit.paid == 0 &&
                  <Text style={tw`font-500`}>Pendiente de pago</Text>
              }
            </View>

            {
              hasPayments &&
              <View style={tw`mb-6 mt-4`}>
                <Text style={tw`text-gray-400 text-xl`}>Pagos</Text>

                <View style={tw`mt-2`}>
                  {
                    
                    feeUnit.payments?.map(payment => {
                      const createdAt = dayjs(payment.created_at)

                      return (
                        <TouchableOpacity
                          onPress={() => setShownPaymentId(payment.uuid)}
                          style={tw`bg-white rounded-2xl border border-gray-200 px-4 py-3 mb-3 row items-center justify-between`}
                          key={payment.uuid}
                        >
                          <View style={tw``}>
                            {
                              payment.folio &&
                                <Text style={tw`text-gray-500 text-lg`}>#{payment.folio}</Text>
                            }

                            <Text style={tw`text-gray-500`}>{createdAt?.format('D/MMM/YYYY')}</Text>
                            <Text style={tw`text-gray-500`}>${payment.pivot.amount} - {payment.payment_method?.name}</Text>
                          </View>

                          <ChevronChico style={tw`ml-2`} />
                        </TouchableOpacity>
                      )
                    })
                  }
                </View>

              </View>
            }

            {
              hasEvidences &&
              <View style={tw`mb-6`}>
                <Text style={tw`text-gray-500 text-lg`}>Comprobante</Text>

                <View style={tw``}>
                  {
                    feeUnit.evidences?.map(evidence => {
                      const createdAt = dayjs(evidence.created_at)
                      
                      return (
                        <View style={tw``}>
                          <Text style={tw`text-gray-500`}>{createdAt?.format('D/MMM/YYYY')}</Text>
                          <Text style={tw`text-gray-500`}>${evidence.amount}</Text>

                          <Image source={evidence.images[0].url} style={tw`w-full h-80`} contentFit='contain' />
                        </View>
                      )
                    })
                  }
                </View>

              </View>
            }


            {/* Excepción a botones de ancho completo: acción destructiva secundaria, chica a la derecha. */}
            <TouchableOpacity style={tw`mt-20 self-end border border-red rounded-full px-4 py-1.5`} onPress={confirFeeUnitDeletion}>
              <Text style={tw`text-red font-500`}>Eliminar adeudo</Text>
            </TouchableOpacity>
          </View>
          
        }
      </ScrollView>

      {
        shownPaymentId &&
          <PaymentDetailModal
            onRequestClose={() => setShownPaymentId()} 
            paymentId={shownPaymentId}
            onPaymentEdited={refetch}
            onPaymentDeleted={() => {
              setShownPaymentId()
              refetch()
            }}
          />
      }
    </>
  )
}